import { getData, updateData } from "@/request/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useDevNotifications = () => {
  return useQuery({
    queryKey: ["dev-notifications"],
    queryFn: async () => (await getData("notifications/dev/inbox")).data,
    refetchInterval: 60 * 1000,
    staleTime: 20 * 1000,
  });
};

export const useDevUnreadCount = () => {
  return useQuery({
    queryKey: ["dev-notifications-unread"],
    queryFn: async () =>
      (await getData("notifications/dev/inbox/unread-count")).data?.unread ?? 0,
    refetchInterval: 60 * 1000,
    staleTime: 20 * 1000,
  });
};

export const useMarkDevRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) =>
      (await updateData(`notifications/dev/inbox/${id}/read`, {})).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dev-notifications"] });
      qc.invalidateQueries({ queryKey: ["dev-notifications-unread"] });
    },
  });
};

export const useMarkAllDevRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () =>
      (await updateData("notifications/dev/inbox/read-all", {})).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dev-notifications"] });
      qc.invalidateQueries({ queryKey: ["dev-notifications-unread"] });
    },
  });
};
